<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ApplyDetail slot-scope="{data}" :form-data="data"></ApplyDetail>
  </l-cache>
</template>
<script>
  import ApplyDetail from './applyDetail'
  export default {
    name: 'reviewDetailBox',
    components: {ApplyDetail},
    methods: {
      async getItem (key) {
        let {items} = await this.$store.dispatch('school/getExtraSignList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
    }
  }
</script>
